import RequestType from '@Enum/RequestTypes.enum';
import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useRequestDictionaryLoader = (): RequestType | undefined => {
  const { pathname } = useLocation();
  const [requestName, setRequestName] = useState<RequestType>();

  useLayoutEffect(() => {
    if (
      pathname.includes('profile') ||
      pathname.includes('leave-request') ||
      pathname.includes('Leave')
    ) {
      setRequestName(RequestType.LEAVE);
    }

    if (
      pathname.includes('passport-request') ||
      pathname.includes('Passport')
    ) {
      setRequestName(RequestType.PASSPORT);
    }

    if (
      pathname.includes('salary-certificate') ||
      pathname.includes('Salary')
    ) {
      setRequestName(RequestType.SALARY);
    }

    if (
      pathname.includes('resumption-requests') ||
      pathname.includes('Resumption')
    ) {
      setRequestName(RequestType.RESUMPTION);
    }

    if (
      pathname.includes('resignation-requests') ||
      pathname.includes('Resignation')
    ) {
      setRequestName(RequestType.RESIGNATION);
    }

    if (pathname.includes('it-request') || pathname.includes('IT')) {
      setRequestName(RequestType.IT_REQUISITION);
    }

    if (
      pathname.includes('overseas-mission') ||
      pathname.includes('Overseas')
    ) {
      setRequestName(RequestType.OVERSEAS);
    }

    if (
      pathname.includes('profile') ||
      pathname.includes('attendance-request') ||
      pathname.includes('Attendance')
    ) {
      setRequestName(RequestType.ATTENDANCE);
    }
  }, [pathname]);

  return requestName;
};

export default useRequestDictionaryLoader;
